module.exports = __webpack_public_path__ + "static/img/nike.f043686.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/NikeWebGL/element/Menu/img/nike.png
// module id = 517
// module chunks = 0